import React from 'react';
import { Table } from 'antd';
import { Store } from 'lucide-react';
import { StatusTag, EmptyState } from '../../../common';

export default function AuditorStoreTable({ stores }) {
    const StoreColumns = [
        {
            title: 'Nombre',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <span className="text-sm font-medium text-surface-900">{text}</span>,
        },
        {
            title: 'Rif',
            dataIndex: 'rif',
            key: 'rif',
            render: (text) => <span className="text-sm text-surface-600 tabular-nums">{text}</span>,
        },
        {
            title: 'Canal',
            dataIndex: 'channel',
            key: 'channel',
            render: (text) => <StatusTag tone={text === 'moderno' ? 'info' : 'warning'}>{text === 'moderno' ? 'MODERNO' : 'TRADICIONAL'}</StatusTag>,
        },
        {
            title: 'Activo',
            dataIndex: 'active',
            key: 'active',
            render: (text) => (
                <StatusTag tone={text ? 'success' : 'danger'} dot>
                    {text ? 'Activo' : 'Inactivo'}
                </StatusTag>
            ),
        },
    ];
    return (
        <Table
            columns={StoreColumns}
            dataSource={stores}
            rowKey="_id"
            size="middle"
            scroll={{ x: 'max-content' }}
            pagination={{ pageSize: 20 }}
            locale={{ emptyText: <EmptyState icon={<Store />} title="Sin pisos asignados" description="Usa “Editar pisos” para asignar pisos de venta" /> }}
        />
    );
}
